"use client";

import { useSendPixelReadyAfterConsent } from "@/app/_utilities/cookiebot";
import { env } from "@/env";
import Script from "next/script";
import ReactDOM from "react-dom";
import { isOptedOutCCPA } from "./ccpa";
import { isGPCEnabled } from "./gpc";

export const ThirdPartyScripts = () => {
  // used to send user attributes and consent to GTM
  useSendPixelReadyAfterConsent();
  ReactDOM.preconnect("https://www.googletagmanager.com");
  ReactDOM.preconnect("https://consentcdn.cookiebot.com");
  ReactDOM.preconnect("https://consent.cookiebot.com");
  ReactDOM.preload("https://consent.cookiebot.com/uc.js", { as: "script", fetchPriority: "high" });

  return (
    <>
      <Script
        data-cbid={env.NEXT_PUBLIC_COOKIEBOT_DOMAIN_ID}
        data-consentmode-defaults='disabled'
        defer
        id='Cookiebot'
        src='https://consent.cookiebot.com/uc.js'
        strategy='afterInteractive'
      />
      <Script
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}

          gtag('consent', 'default', {
              'ad_personalization': 'denied',
              'analytics_storage': 'denied',
              'ad_storage': 'denied',
              'ad_user_data': 'denied',
              'functionality_storage': 'denied',
              'personalization_storage': 'denied',
              'security_storage': 'granted',
              'wait_for_update': 500,
              'region':
              [
                'AD', 'AL', 'AM', 'AT', 'AZ', 'BA', 'BE', 'BG', 'BY', 'CH', 'CY', 'CZ',
                'DE', 'DK', 'EE', 'ES', 'FI', 'FO', 'FR', 'GB', 'GE', 'GG', 'GI', 'GR',
                'HR', 'HU', 'IC', 'IE', 'IM', 'IS', 'IT', 'JE', 'KZ', 'LI', 'LT', 'LU',
                'LV', 'MC', 'MD', 'ME', 'MK', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'RS',
                'RU', 'SE', 'SI', 'SJ', 'SK', 'SM', 'TR', 'UA', 'VA'
            ]
          });

          gtag('consent', 'default', {
            'ad_personalization': 'granted',
            'analytics_storage': 'granted',
            'ad_storage': 'granted',
            'ad_user_data': 'granted',
            'functionality_storage': 'granted',
            'personalization_storage': 'granted',
            'security_storage': 'granted',
            'wait_for_update': 500
        });

          gtag('set', 'ads_data_redaction', true);
          gtag('set', 'url_passthrough', true);

          gtag ('config', '${env.NEXT_PUBLIC_GTM_ID}', {'restricted_data_processing': ${isOptedOutCCPA() || isGPCEnabled() ? "true" : "false"} } )

          dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
          `,
        }}
        data-cookieconsent='ignore'
        id='google-consent-mode-gtm'
        strategy='beforeInteractive'
      />
      <Script
        dangerouslySetInnerHTML={{
          __html: `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=${env.NEXT_PUBLIC_GTM_AUTH}&gtm_preview=env-${env.NEXT_PUBLIC_GTM_ENV}&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${env.NEXT_PUBLIC_GTM_ID}');`,
        }}
        data-cookieconsent='ignore'
        id='google-gtm'
        strategy='afterInteractive'
      />

      <Script
        dangerouslySetInnerHTML={{
          __html: `
        (function(){var dbpr=100;if(Math.random()*100>100-dbpr){var d="dbbRum",w=window,o=document,a=addEventListener,scr=o.createElement("script");scr.async=!0;w[d]=w[d]||[];w[d].push(["presampling",dbpr]);["error","unhandledrejection"].forEach(function(t){a(t,function(e){w[d].push([t,e])});});scr.src="https://cdn.debugbear.com/k9KENAYKvzKc.js";o.head.appendChild(scr);}})()
        `,
        }}
        defer
        id='debugbear'
      />
    </>
  );
};
